import { Product } from '@/services/api/contracts/catalog/types';
import { FunctionComponent, useEffect } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { useSnapCarousel } from 'react-snap-carousel';
import CatalogueExplorerProductCard from '../explorer/CatalogueExplorerProductCard';

interface ProductCarouselProps {
  products: Product[];
}

const CAROUSEL_ROWS = 1;

const ProductCarousel: FunctionComponent<ProductCarouselProps> = ({ products }) => {
  const productRows: Product[][] = [];
  products.forEach((product, index) => {
    if (index % CAROUSEL_ROWS === 0) {
      const newPair = [product];
      productRows.push(newPair);
    } else {
      productRows[productRows.length - 1].push(product);
    }
  });

  const { refresh, scrollRef, pages, activePageIndex, next, prev, goTo } = useSnapCarousel();

  useEffect(() => {
    refresh();
  }, [products]);

  const firstPage = activePageIndex === 0;
  const lastPage = activePageIndex === pages.length - 1;

  const onBack = () => {
    if (firstPage) {
      goTo(pages.length - 1);
    } else {
      prev();
    }
  };

  const onNext = () => {
    if (lastPage) {
      goTo(0);
    } else {
      next();
    }
  };

  return (
    <div className="flex md:gap-2 items-center text-primary-800 max-w-[calc(100vw-25rem)]">
      <button onClick={onBack}>
        <FiChevronLeft className={`h-8 md:h-12 w-8 md:w-12`} />
      </button>
      <div className="w-full overflow-x-hidden">
        <ul className="flex overflow-x-hidden overflow-y-auto snap-x snap-mandatory no-scroll-bar" ref={scrollRef}>
          {productRows.map((row, index) => {
            return (
              <li
                key={`product-row-${row[0].category.id}-${index}`}
                className="flex-col w-1/4 flex gap-2 md:gap-5 flex-none px-1 md:px-2"
              >
                {row.map(product => (
                  <CatalogueExplorerProductCard product={product} key={product.id} />
                ))}
              </li>
            );
          })}
        </ul>
      </div>

      <button onClick={onNext}>
        <FiChevronRight className={`h-8 md:h-12 w-8 md:w-12`} />
      </button>
    </div>
  );
};

export default ProductCarousel;
